import { useState } from 'react';
import { getDynamicEnvVarsInClient } from '@/utils/envHelper';
import axios from 'axios';
import { toast } from 'sonner';

const useOtpSend = (emailTemplateId: number) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>('');
  const [error, setError] = useState<string>('');

  const { NEXT_PUBLIC_API_URL } = getDynamicEnvVarsInClient();
  const handleClick = async (
    email: string,
    tenantId: string,
    type: string,
    fromSignup?: boolean,
    wrongEmail?: string
  ) => {
    if (email) {
      setError('');
      setLoading(true);
      try {
        const url = NEXT_PUBLIC_API_URL;
        const res = await axios.post(`${url}/send-otp`, {
          email: email?.toLowerCase(),
          tenantId,
          type,
          ...(fromSignup ? { fromSignup } : {}),
          ...(wrongEmail ? { wasWrongEmail: true } : {}),
          ...(wrongEmail ? { wrongEmail } : {}),
          emailTemplateId,
        });
        if (res.data) {
          setData(res.data);
        }
      } catch (error: any) {
        const axiosError = error;
        if (axiosError.response) {
          setError(axiosError?.response?.data?.message || 'An error occurred');
        } else if (axiosError.request) {
          setError('Request failed, please try again later');
        } else {
          setError('An error occurred, please try again later');
        }
      } finally {
        setLoading(false);
      }
    } else {
      toast.error('Email required');
    }
  };

  return {
    loading,
    handleClick,
    data,
    error,
  };
};

export default useOtpSend;
